import type { Observable } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { PollResponse } from './types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	projectKey: string,
	baseUrl: string,
	projectStateHash: string,
): Observable<PollResponse> => {
	const params = new URLSearchParams();

	if (fg('add-operation-query-param-to-queues-endpoints')) {
		if (projectStateHash) {
			params.set('projectStateHash', projectStateHash);
		}
		params.set('operation', 'fetchQueuesPoll');
	}

	const queryString = params.size ? `?${params.toString()}` : '';

	const hashString = projectStateHash ? `?projectStateHash=${projectStateHash}` : '';

	return fetchJson$(
		`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/poll${fg('add-operation-query-param-to-queues-endpoints') ? queryString : hashString}`,
		{
			method: 'GET',
		},
	);
};
